<template>
  <div id="footWrapper">
    <section id="foot">
      <ul>
        <li><a href="https://www.ng-accounting.com">
          <p>Need an Accountant?</p>
          <img src="../../../public/img/icons/nga.png" alt />
        </a></li>
        <li><a href="mailto:ngconstructioninc@yahoo.com">
          <p>Email us now and we will Contact you as soon as possible</p>
        </a></li>
        <li><a href="sms:+1-509-981-2876">
          <p>
            Feel Free to send us a text Message so we can set up an appointment today
            <br />509-981-2876
          </p>
        </a></li>
      </ul>
    </section>
    <footer id="footer">
      <h4>
        Neil Green
        <br />NG Construction Inc.
        <br />P.O. Box 4154 Spokane, WA 99220
        <br />NG Construction&copy;
      </h4>
    </footer>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>

#footWrapper {
  clear: both;
}

#foot {
  position: relative;
  margin: 0 auto;
  padding: 0 0 0 0;
  background-color: #4e606e;
}

#foot > ul {
  margin: 0 auto;
  padding: 0;
  text-align: center;
  width: 100%;
  display: flex;
}

#foot > ul > li {
  margin: 0 auto;
  padding: 0;
  justify-content: space-evenly;
  width: 33.33%;
  list-style: none;
    max-width: 33.33%;
}

#foot > ul > li > a > p {
  color: white;
text-align: center;
padding: 0 10px 0 10px;
}

#foot > ul > li > a > p:hover {
color: black;
transition: 1s;
}
a {
  text-decoration: none;
}
#foot > ul > li > a > img {
  width: 40%;
}

#foot > p,
#footer > h4 {
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  width: 300px;
  color: white;
  text-align: center;
}

#footer {
  position: relative;
    margin: 0 auto;
  padding-bottom: 20px;
  background-color: #4e606e;
}

@media screen and (max-width: 600px){

#foot {
  position: relative;
  top: 20px;
  padding-bottom: 20px;
}
  #foot > ul {
    position: relative;
    display: inline;
  }

  #foot > ul > li {
  clear:both;
  display: inline;
}

  #foot > p,
  #foot > ul > li > a,
#footer > h4 {
width: 100%;
}
}
</style>
